import React, { useContext, useEffect } from "react";
import Login from "../../Templates/Auth/Login/Login";
import { useNavigate } from "react-router-dom";
import { userContext } from "../../Contexts/userContext";

function LoginPage() {
  const navigate = useNavigate();
  const { contextData } = useContext(userContext);

  useEffect(() => {
    if (localStorage.getItem("isLogged") == "true")
      if (contextData?.role == "admin" || contextData?.role == "school")
        navigate("/");
      else navigate("/classes");
  }, [contextData]);
  

  return <Login />;
}

export default LoginPage;
